"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTasksFilterOnCreateTask = exports.createTask = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const sok_types_1 = require("@caddigital/sok-types");
const ActionTypes = require("../../actionTypes/tasks/crud");
const Actions = require("../../actions/tasks/crud");
const ListActions = require("../../actions/tasks/list");
function createTask(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_MARKING_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            Authorization: getToken(),
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: request.payload,
        url: `${baseUrl}api/tasks/file/${request.payload.fileId}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const act = sok_types_1.Marking.iMarking
            .decode(response)
            .fold((_) => Actions.createMarkingFailed(), (e) => Actions.createMarkingSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((_) => (0, rxjs_1.of)(Actions.createMarkingFailed())))));
}
exports.createTask = createTask;
function applyTasksFilterOnCreateTask(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_MARKING_SUCCESS), (0, operators_1.mergeMap)(({ payload }) => {
        const state = store.value;
        const act = state.auth.current.user.fold(ListActions.setLayerFilter(state.tasks.list.layerFilter), (user) => ListActions.setLayerFilter(state.tasks.list.layerFilter, user));
        return (0, rxjs_1.of)(act);
    }));
}
exports.applyTasksFilterOnCreateTask = applyTasksFilterOnCreateTask;
//# sourceMappingURL=crud.js.map